import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { AggregatorLoanAndMortgageBox } from 'components/aggregator/aggregatorBoxes/aggregatorLoanAndMortgageBox/aggregatorLoanAndMortgageBox';
import { AggregatorGenericView } from './aggregatorGenericView/aggregatorGenericView';

import { NOT_ALLOWED_TINK_AGGREGATOR } from 'constants/flagBasedFeatures';

import { LOANSANDMORTGAGES } from 'constants/aggregator/products';

class AggregatorLoansAndMortgagesViewClass extends React.PureComponent {
  getProductComponent(product, isTinkAggregator) {
    const userBankId = product.get('userBankId');

    return (
      <AggregatorLoanAndMortgageBox
        key={userBankId}
        loanMortgages={product}
        isTinkAggregator={isTinkAggregator}
      />
    );
  }

  render() {
    const { immFlagBasedFeatures } = this.props;

    const isTinkAggregator = immFlagBasedFeatures.get(NOT_ALLOWED_TINK_AGGREGATOR);

    return (
      <AggregatorGenericView
        hasDetails={false}
        productType={LOANSANDMORTGAGES}
        getProductComponent={this.getProductComponent}
        isTinkAggregator={isTinkAggregator}
      />
    );
  }
}

AggregatorLoansAndMortgagesViewClass.propTypes = {
  immFlagBasedFeatures: PropTypes.object,
};

AggregatorLoansAndMortgagesViewClass.defaultProps = {
  immFlagBasedFeatures: {},
};

const AggregatorLoansAndMortgagesView = connect(state => {
  return {
    immFlagBasedFeatures: state.flagBasedFeatures,
  };
})(AggregatorLoansAndMortgagesViewClass);

export { AggregatorLoansAndMortgagesView };
